import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewAppAreas from './viewRelatedAppAreas';
import viewRelatedRoomTags from './viewRelatedRoomTags';
import viewRelatedSportRoomTags from './viewRelatedSportRoomTags';

export default {
  attributeName: 'thirdPartyAuthProvider',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.MAIN_HUB_THIRD_PARTY_NEW,
  editURL: routes.MAIN_HUB_THIRD_PARTY_EDIT,
  emptyMessage: "You don't have provider, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'ID.',
      hidden: true
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Name provider.',
    },
     {
      attributeName: 'thirdPartyType',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Type provider.',
    },
    {
      attributeName: 'description',
      label: 'Description',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Description provider.',
    },
  ],
};
